import './App.css';
import { AppProvider, useApp } from './AppContext';
import Onboard from './screens/Onboard';
import Auth from './screens/Auth';
import Main from './screens/Main';
import Toast from './components/Toast';

function AppShell() {
  const { screen, authLoading, magicLinkError, setScreen, setAuthMode } = useApp();

  if (authLoading) {
    return (
      <div className="app splash">
        <div className="splash-moon">☽</div>
        <div className="splash-text">Mercy</div>
        <style>{`
          .splash { align-items: center; justify-content: center; gap: 12px; }
          .splash-moon { font-size: 40px; animation: pulse 1.5s ease-in-out infinite; }
          .splash-text { font-family: 'Cormorant Garamond', serif; font-size: 22px; color: var(--gold); letter-spacing: 0.1em; animation: pulse 1.5s ease-in-out infinite; }
          @keyframes pulse { 0%,100%{opacity:0.25} 50%{opacity:1} }
        `}</style>
      </div>
    );
  }

  if (magicLinkError) {
    return (
      <div className="app" style={{ alignItems: 'center', justifyContent: 'center', padding: '32px', textAlign: 'center', gap: 16 }}>
        <div style={{ fontSize: 36 }}>✉️</div>
        <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 24, color: 'var(--text)' }}>Link expired</div>
        <div style={{ fontSize: 13, color: 'var(--text-dim)', lineHeight: 1.65, maxWidth: 260 }}>
          This sign-in link has expired or already been used. Please request a new one.
        </div>
        <button className="btn btn-primary" style={{ marginTop: 8 }} onClick={() => { setAuthMode('login'); setScreen('auth'); }}>
          Try again
        </button>
      </div>
    );
  }

  return (
    <div className="app">
      {screen === 'onboard' && <Onboard />}
      {screen === 'auth'    && <Auth />}
      {screen === 'main'    && <Main />}
      <Toast />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <AppShell />
    </AppProvider>
  );
}
